import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { get } from "../services/ApiService";

const ChatCountsContext = createContext({});

export const ChatCountsProvider = ({ children }) => {
  const [counts, setCounts] = useState({});
  const isAuthenticated = useSelector((state) => state.isAuthenticated);

  const refresh = useCallback(async () => {
    try {
      const res = await get("api/messages/type/counts");
      if (res.success && res.counters) {
        setCounts(res.counters);
      }
    } catch (error) {
      console.error("Error fetching chat counts:", error);
    }
  }, []);

  useEffect(() => {
    if (!isAuthenticated) return;
    refresh();
    const interval = setInterval(refresh, 60000);
    return () => clearInterval(interval);
  }, [refresh, isAuthenticated]);

  return (
    <ChatCountsContext.Provider value={{ counts, refresh }}>
      {children}
    </ChatCountsContext.Provider>
  );
};

export const useChatCounts = () => useContext(ChatCountsContext);
